import { render, staticRenderFns } from "./BillHeader.vue?vue&type=template&id=e2816d4a&scoped=true&"
import script from "./BillHeader.vue?vue&type=script&lang=ts&"
export * from "./BillHeader.vue?vue&type=script&lang=ts&"
import style0 from "./BillHeader.vue?vue&type=style&index=0&id=e2816d4a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2816d4a",
  null
  
)

export default component.exports